/* BJP: show whole-dollar prices without trailing zeros ($39 instead of $39.00); prices with cents like $29.99 stay unchanged. */
(function () {
  if (typeof window.btyFormatPrice !== 'function') return;
  var original = window.btyFormatPrice;
  window.btyFormatPrice = function (money, format) {
    var s = original(money, format);
    return typeof s === 'string' ? s.replace(/([.,]00)(?!\d)/, '') : s;
  };
})();
